import {Injectable, Injector} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import {UtilisateurCourantService} from '../services/utilisateurs/utilisateur-courant.service';
import {catchError, filter, switchMap, tap} from 'rxjs/operators';
import {AutorisationsAggregate} from '../aggregats/autorisation/autorisations.aggregate';
import {NavigationService} from '../navigation/services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizedGuard  {
  private readonly AUTORISATIONS: string = 'autorisations';

  constructor(
    private userService: UtilisateurCourantService,
    private router: Router,
    private injector: Injector,
    private navigationService: NavigationService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    return this.userService.isLogguedIn()
    .pipe(
      tap(isLogguedIn => {
        if (!isLogguedIn) {
          this.router.navigate([''])
        }
      }),
      filter(isLogguedIn => isLogguedIn),
      switchMap(() => this.userService.getInformationsProfilUtilisateur()),
      switchMap(profilInformations => {        
        const autorisations: AutorisationsAggregate = route.data[this.AUTORISATIONS];
        if (autorisations) {
          return autorisations.isAuthorizedForContext({
            droits: profilInformations.droits,
            injectorContext: this.injector,
          });
        }
        return of(true);
      }),
      catchError(() => {
        return of(false);
      }),
      tap(isAuthorized => {        
        if (!isAuthorized) {
          this.navigationService.root.non_autorise.navigate();
        }
      }),
    );
  }
}
